// extracted by mini-css-extract-plugin
export default {"inputholder":"Feedback_inputholder__xLVi4","inputbox":"Feedback_inputbox__t7urb","save":"Feedback_save__Rl6F8","cancel":"Feedback_cancel__Qgq3i"};